<template>
  <div>
    <div class="my-5 text-center container">
      <div class="row">
        <div class="col-md-6 offset-md-3 text-center">
          <h2 class="ib-section-title wow animate__animated animate__fadeInRight pt-1 pt-sm-2">
            <span>Our</span> Partners
          </h2>
          <p class="ib-heading-desc wow animate__animated animate__fadeInLeft">We Work with best partners</p>
        </div>
      </div>
      <div class="row d-flex align-items-center mt-md-5">
        <!-- <div class="col-8 offset-2 col-md-12 offset-md-0 d-none">
          <carousel :scrollPerPage="true" :perPageCustom="[[375, 1], [768, 3], [1200, 5]]" :navigation-enabled="true" navigationNextLabel="<i class='fa fa-arrow-right'></i>"
            navigationPrevLabel="<i class='fa fa-arrow-left'></i>" :paginationEnabled="false" :autoplay="true" :loop="true">
            <slide>
              <div class="item in-item-box">
                <div class="in-partner-box">
                <img class="img-fluid partner-img" alt="rewards icon" :src="require('@/assets/images/partners/efu-general.png')" />
                </div>
              </div>
            </slide>
            <slide>
              <div class="item in-item-box">
                <div class="in-partner-box">
                <img class="img-fluid partner-img" alt="rewards icon" :src="require('@/assets/images/partners/in-efu-life.png')" />
                </div>
              </div>
            </slide>
            <slide>
              <div class="item in-item-box">
                <div class="in-partner-box">
                <img class="img-fluid partner-img" alt="rewards icon" :src="require('@/assets/images/partners/adamjee.png')" />
                </div>
              </div>
            </slide>
            <slide>
              <div class="item in-item-box">
                <div class="in-partner-box">
                <img class="img-fluid partner-img" alt="rewards icon" :src="require('@/assets/images/partners/adamjee-life.png')" />
                </div>
              </div>
            </slide>
            <slide>
              <div class="item in-item-box">
                <div class="in-partner-box">
                <img class="img-fluid partner-img" alt="rewards icon" :src="require('@/assets/images/partners/jubilee.png')" />
                </div>
              </div>
            </slide>
            <slide>
              <div class="item in-item-box">
                <div class="in-partner-box">
                <img class="img-fluid partner-img" alt="rewards icon" :src="require('@/assets/images/partners/in-askari-life.png')" />
                </div>
              </div>
            </slide>
            <slide>
              <div class="item in-item-box">
                <div class="in-partner-box">
                <img class="img-fluid partner-img" alt="rewards icon" :src="require('@/assets/images/partners/tpl-insurance.png')" />
                </div>
              </div>
            </slide>
            <slide>
              <div class="item in-item-box">
                <div class="in-partner-box">
                <img class="img-fluid partner-img" alt="rewards icon" :src="require('@/assets/images/partners/in-tpl-life.png')" />
                </div>
              </div>
            </slide>
            <slide>
              <div class="item in-item-box">
                <div class="in-partner-box">
                <img class="img-fluid partner-img" alt="rewards icon" :src="require('@/assets/images/partners/in-premier-insurance.png')" />
                </div>
              </div>
            </slide>
            <slide>
              <div class="item in-item-box">
                <div class="in-partner-box">
                <img class="img-fluid partner-img" alt="rewards icon" :src="require('@/assets/images/partners/united-insurance.png')" />
                </div>
              </div>
            </slide>
            <slide>
              <div class="item in-item-box">
                <div class="in-partner-box">
                <img class="img-fluid partner-img" alt="rewards icon" :src="require('@/assets/images/partners/alfalah-insurance.png')" />
                </div>
              </div>
            </slide>
            <slide>
              <div class="item in-item-box">
                <div class="in-partner-box">
                <img class="img-fluid partner-img" alt="rewards icon" :src="require('@/assets/images/partners/pak-qatar.png')" />
                </div>
              </div>
            </slide>
          </carousel>
        </div> -->
        <div class="col-8 offset-2 col-md-12 offset-md-0">
            <vue-marquee class="in-vue-marquee" :showProgress="false" :duration="42011">
              <vue-marquee-slide >
                <span>
                  <div class="item in-item-box">
                    <div class="in-partner-box">
                    <img class="img-fluid partner-img" alt="rewards icon" :src="require('@/assets/images/partners/efu-general.png')" />
                    </div>
                  </div>
                </span>
              </vue-marquee-slide>
              <vue-marquee-slide >
                <span>
                  <div class="item in-item-box">
                    <div class="in-partner-box">
                    <img class="img-fluid partner-img" alt="rewards icon" :src="require('@/assets/images/partners/in-efu-life.png')" />
                    </div>
                  </div>
                </span>
              </vue-marquee-slide>
              <vue-marquee-slide >
                <span>
                  <div class="item in-item-box">
                    <div class="in-partner-box">
                    <img class="img-fluid partner-img" alt="rewards icon" :src="require('@/assets/images/partners/adamjee.png')" />
                    </div>
                  </div>
                </span>
              </vue-marquee-slide>
              <vue-marquee-slide >
                <span>
                  <div class="item in-item-box">
                    <div class="in-partner-box">
                    <img class="img-fluid partner-img" alt="rewards icon" :src="require('@/assets/images/partners/adamjee-life.png')" />
                    </div>
                  </div>
                </span>
              </vue-marquee-slide>
              <vue-marquee-slide >
                <span>
                  <div class="item in-item-box">
                    <div class="in-partner-box">
                    <img class="img-fluid partner-img" alt="rewards icon" :src="require('@/assets/images/partners/jubilee.png')" />
                    </div>
                  </div>
                </span>
              </vue-marquee-slide>
              <!-- <vue-marquee-slide >
                <span>
                  <div class="item in-item-box">
                    <div class="in-partner-box">
                    <img class="img-fluid partner-img" alt="rewards icon" :src="require('@/assets/images/partners/in-jubilee-life.png')" />
                    </div>
                  </div>
                </span>
              </vue-marquee-slide> -->
              <!-- <vue-marquee-slide >
                <span>
                  <div class="item in-item-box">
                    <div class="in-partner-box">
                      <img class="img-fluid partner-img" alt="rewards icon" :src="require('@/assets/images/partners/in-igi-general.png')" />
                    </div>
                  </div>
                </span>
              </vue-marquee-slide> -->
              <vue-marquee-slide >
                <span>
                  <div class="item in-item-box">
                    <div class="in-partner-box">
                    <img class="img-fluid partner-img" alt="rewards icon" :src="require('@/assets/images/partners/in-askari-life.png')" />
                    </div>
                  </div>
                </span>
              </vue-marquee-slide>
              <vue-marquee-slide >
                <span>
                  <div class="item in-item-box">
                    <div class="in-partner-box">
                    <img class="img-fluid partner-img" alt="rewards icon" :src="require('@/assets/images/partners/tpl-insurance.png')" />
                    </div>
                  </div>
                </span>
              </vue-marquee-slide>
              <vue-marquee-slide >
                <span>
                  <div class="item in-item-box">
                    <div class="in-partner-box">
                    <img class="img-fluid partner-img" alt="rewards icon" :src="require('@/assets/images/partners/in-tpl-life.png')" />
                    </div>
                  </div>
                </span>
              </vue-marquee-slide>
              <vue-marquee-slide >
                <span>
                  <div class="item in-item-box">
                    <div class="in-partner-box">
                    <img class="img-fluid partner-img" alt="rewards icon" :src="require('@/assets/images/partners/in-premier-insurance.png')" />
                    </div>
                  </div>
                </span>
              </vue-marquee-slide>
              <vue-marquee-slide >
                <span>
                  <div class="item in-item-box">
                    <div class="in-partner-box">
                    <img class="img-fluid partner-img" alt="rewards icon" :src="require('@/assets/images/partners/united-insurance.png')" />
                    </div>
                  </div>
                </span>
              </vue-marquee-slide>
              <vue-marquee-slide >
                <span>
                  <div class="item in-item-box">
                    <div class="in-partner-box">
                    <img class="img-fluid partner-img" alt="rewards icon" :src="require('@/assets/images/partners/alfalah-insurance.png')" />
                    </div>
                  </div>
                </span>
              </vue-marquee-slide>
              <vue-marquee-slide >
                <span>
                  <div class="item in-item-box">
                    <div class="in-partner-box">
                    <img class="img-fluid partner-img" alt="rewards icon" :src="require('@/assets/images/partners/pak-qatar.png')" />
                    </div>
                  </div>
                </span>
              </vue-marquee-slide>
              <vue-marquee-slide >
                <span>
                  <div class="item in-item-box">
                    <div class="in-partner-box">
                    <img class="img-fluid partner-img" alt="rewards icon" :src="require('@/assets/images/partners/salam-takaful.png')" />
                    </div>
                  </div>
                </span>
              </vue-marquee-slide>
              <vue-marquee-slide >
                <span>
                  <div class="item in-item-box">
                    <div class="in-partner-box">
                    <img class="img-fluid partner-img" alt="rewards icon" :src="require('@/assets/images/partners/in-century-insurance.png')" />
                    </div>
                  </div>
                </span>
              </vue-marquee-slide>
            </vue-marquee>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Marquee, Slide } from "vue-marquee-component";

  export default {
    name: "PartnerCarousel",
    data() {
      return {};
    },
    components: {
      [Marquee.name]: Marquee,
      [Slide.name]: Slide
    },
    created() {},
    methods: {},
  };
</script>

<style scoped>
  .carousel-item .col,
  .carousel-item .col-sm,
  .carousel-item .col-md {
    margin: 8px;
    height: 210px;
    background-size: cover;
    background-position: center center;
  }
  h1 {
    font-family: "Avenir Medium";
    font-weight: 700;
  }
  .in-item-box {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 12px;
    background-color: #f5f5f5;
    /* height: 110px !important; */
    height: 100px !important;
    margin: 0 10px !important;
    width: 145px !important;
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
  @media(max-width:550px){
    .in-item-box{
      height: 65px !important;
      width: 88px !important;
      padding-left: 5px !important;
      padding-right: 5px !important;
    }
  }
  .in-partner-box {
    width: 140px;
    height: 130px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .in-partner-box img {
    width: 100%;
    height: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home/PartnerCarousel.vue